/**
 * Items introduced in the latest server update (~every 15 days).
 *
 * These get sorted to the TOP of their slot's list and show a red "N" badge.
 * To rotate: replace the IDs below with the new update's items and redeploy —
 * the previous batch automatically falls back to its normal position and loses
 * the badge.
 */
export const NEW_ITEM_IDS = new Set([
  // 2026-10-15 update. RagnaPlace re-stamped most of the 10-01 batch on 13-14/10,
  // but the Halloween and Malangdo visual events run until 26/10, so those are
  // still current and keep the badge alongside the five new 15/10 entries.
  // Not listed: effect-only 420337 420446 410280; render on neither backend
  // 480772 420597 420593 420445 410395 20211 20210 and 420439 Kombi do Quitute.
  31975, 31912, 20987, 480503, 31473, 480437, 420367, 420336, 400422, 31442,
  480235, 410201, 410060, 400160, 400091, 20472, 20410, 20348, 20130, 20054,
  19913, 19904, 19893, 19797, 420025, 410198, 400739, 31312, 19980, 19979,
  19978, 19977, 19713, 19618, 480431, 480430, 420366, 420346, 420325, 410399,
  410316, 410011, 400803, 400136, 20494,
]);

export const isNewItem = (id) => NEW_ITEM_IDS.has(parseInt(id, 10));
